import { createIcon } from "@chakra-ui/react";

export const Handshake = createIcon({
  displayName: "Handshake",
  viewBox: "0 0 24 24",
  path: [
    <g clipPath="url(#u1vqt4f2ka)">
      <path
        fill="currentColor"
        d="M9.9 14.875c1.492 0 2.7-1.195 2.7-2.672v-.297h3.9c.499 0 .9.397.9.89a.895.895 0 0 1-.728.876.899.899 0 0 0-.652.512.88.88 0 0 0 .052.824.893.893 0 0 1-.772 1.35c-.499.001-.9.398-.9.892 0 .326-.27.593-.6.593H9.499c-.56 0-1.092.22-1.485.609l-2.052 2.026a.88.88 0 0 0 0 1.258.906.906 0 0 0 1.272 0L9.28 19.71a.3.3 0 0 1 .214-.085H13.796c1.05 0 1.943-.665 2.269-1.592a2.676 2.676 0 0 0 1.897-2.991 2.656 2.656 0 0 0 1.238-2.245c0-1.477-1.208-2.672-2.7-2.672h-3.9v-.89a.893.893 0 0 0-.9-.892c-.499 0-.9.398-.9.891v2.969c0 .493-.401.89-.9.89a.893.893 0 0 1-.9-.89V8.64c0-.82.671-1.484 1.5-1.484H15.7c.559 0 1.091-.219 1.485-.609l2.051-2.026a.88.88 0 0 0 0-1.258.906.906 0 0 0-1.27 0L15.914 5.29a.299.299 0 0 1-.214.086H10.5c-1.823 0-3.3 1.462-3.3 3.265v3.563c0 1.477 1.207 2.672 2.7 2.672zM6 7.917a2.447 2.447 0 0 0-1.478 1.64l-.81 2.998a.303.303 0 0 1-.078.134L.262 16.025a.88.88 0 0 0 0 1.258.906.906 0 0 0 1.272 0l3.375-3.336c.262-.26.45-.579.543-.935L6 10.982V7.917zm14.37 4.39 3.367-3.333a.88.88 0 0 0 0-1.258.906.906 0 0 0-1.27 0l-2.825 2.795a3.81 3.81 0 0 1 .728 1.8v-.004z"
      />
    </g>,
    <defs>
      <clipPath id="u1vqt4f2ka">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>,
  ],
  defaultProps: {
    "aria-label": "Hands shaking"
  }
});

export default Handshake;
